"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfApiPatchUserRequest = instanceOfApiPatchUserRequest;
exports.ApiPatchUserRequestFromJSON = ApiPatchUserRequestFromJSON;
exports.ApiPatchUserRequestFromJSONTyped = ApiPatchUserRequestFromJSONTyped;
exports.ApiPatchUserRequestToJSON = ApiPatchUserRequestToJSON;
exports.ApiPatchUserRequestToJSONTyped = ApiPatchUserRequestToJSONTyped;
/**
 * Check if a given object implements the ApiPatchUserRequest interface.
 */
function instanceOfApiPatchUserRequest(value) {
    return true;
}
function ApiPatchUserRequestFromJSON(json) {
    return ApiPatchUserRequestFromJSONTyped(json, false);
}
function ApiPatchUserRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'privilege': json['privilege'] == null ? undefined : json['privilege'],
        'firstname': json['firstname'] == null ? undefined : json['firstname'],
        'lastname': json['lastname'] == null ? undefined : json['lastname'],
        'isOverrideLoginMethod': json['is_override_login_method'] == null ? undefined : json['is_override_login_method'],
        'loginMethods': json['login_methods'] == null ? undefined : json['login_methods'],
    };
}
function ApiPatchUserRequestToJSON(json) {
    return ApiPatchUserRequestToJSONTyped(json, false);
}
function ApiPatchUserRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'privilege': value['privilege'],
        'firstname': value['firstname'],
        'lastname': value['lastname'],
        'is_override_login_method': value['isOverrideLoginMethod'],
        'login_methods': value['loginMethods'],
    };
}
